import { LicenseExpireWarning } from '@investigator/features/admin/components';
import { CopyrightPrivacyPolicy } from './CopyrightPrivacyPolicy';

export const SidebarFooterLinks = () => {
  return (
    <>
      <LicenseExpireWarning />
      <CopyrightPrivacyPolicy />
    </>
  );
};
